import React from 'react';
import PropTypes from 'prop-types';
import { Tag, Button } from 'antd';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { VendorList } from '../../../../records/vendor_list_records';
import { Site } from '../../../../records/site_records';
import SelectSitesAndSiteGroups from '../../../common/SelectSitesAndSiteGroups';

export default class ManageSites extends React.Component {
  static propTypes = {
    vendorScanning: PropTypes.bool.isRequired,
    siteAccess: PropTypes.bool,
    readOnly: PropTypes.bool.isRequired,
    sites: ImmutablePropTypes.listOf(PropTypes.instanceOf(Site)).isRequired,
    vl: PropTypes.instanceOf(VendorList).isRequired,
    toggleScanVendors: PropTypes.func.isRequired,
    handleSelectSite: PropTypes.func.isRequired,
    removeSiteByName: PropTypes.func.isRequired,
    toggleAdvancedSettings: PropTypes.func.isRequired,
    toggleDoNotSellSettings: PropTypes.func.isRequired,
  };

  getSiteDomain = (id) => {
    const site = this.props.sites.find(s => s.id === id)
    return site ? site.domain : `no site with id ${id} found`;
  }

  render() {

    let sitesValue = this.props.vl.siteIds;
    if (this.props.siteAccess) {
      sitesValue = sitesValue.filter(id => this.props.siteAccess.includes(id));
    }

    sitesValue = sitesValue.map(id => this.getSiteDomain(id));
    
    let dnsButton;
    if (this.props.dnsButton) {
      dnsButton = (
      <Button
        onClick={ this.props.toggleDoNotSellSettings }
        className='do-not-sell-settings'
        disabled={ !this.props.vl.siteIds.size }
      >
        Do Not Sell settings
      </Button>
      );
    }

    const selectSites = (
      <div className='select-sites-container'>
        <SelectSitesAndSiteGroups
          value={ this.props.vl.siteIds }
          sites={ this.props.sites }
          siteGroups={ this.props.siteGroups }
          onSelect={ this.props.handleSelectSite }
          multiple
          disabled={ this.props.readOnly }
          siteAccess={ this.props.siteAccess }
          placeholder={ 'none' }
        />
        { dnsButton }
      </div>
    );

    let scanForNewVendors;
    if (this.props.vendorScanning && !this.props.readOnly) {
      scanForNewVendors = (
        <div onClick={ this.props.toggleScanVendors } role="presentation">
          <p className='scan-for-new-vendors'>Scan for new vendors</p>
        </div>
      );
    }

    return (
      <div className="vendor-sites">
        <div className="vendor-site-list">
          <span>Select property(s) this list applies to: </span>
        </div>
        <div className="top-of-the-table-container">
          { selectSites }
        </div>
      </div>
    );
  }
}
